module.exports = __webpack_public_path__ + "static/media/ex-about-us.3dc38cad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/assets-for-demo/example-pages/ex-about-us.jpg
// module id = 1218
// module chunks = 0